//
//
//
//
//
//
//
//
//
//
//

import { version } from '../../package.json';

export default {
  name: 'ViuHeader',
  props: {
    /**
     * Decide si mostrar o no el separador.
     * Por defecto no hay separador.
     * @values true, false
     */
    separator: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    version
  })
};
